import React from "react";
import PropTypes from "prop-types";
import { startCase } from "lodash";

import { useBooleanState } from "hooks";

import { useAccessTypeStore } from "scenes/Hubly/components/Workspace/components/hooks";

import { TaskConditionModal, TaskIcon } from "..";

export function Conditions({
  workflowId,
  item,
  itemType,
  checkEligibility,
  onConfigChange,
}) {
  const [isOpen, open, close] = useBooleanState();
  const { hasAccess } = useAccessTypeStore();

  const getConditionModalSubtitle = React.useCallback(() => {
    if (itemType === "task") {
      return item?.title || "New Task";
    }

    if (item?.workflow?.name && item?.nextWorkflow?.name) {
      return `This Workflow: ${item.workflow.name} - Next Workflow: ${item?.nextWorkflow?.name}`;
    } else if (item?.nextWorkflow?.name) {
      return `Next Workflow: ${item?.nextWorkflow?.name}`;
    } else {
      return "New Next Workflow";
    }
  }, [itemType, item]);

  if (item?.conditionsGroup && item?.id) return null;

  return (
    <React.Fragment>
      <TaskIcon
        hasValue={Boolean(item?.conditionsGroup)}
        expanded={isOpen}
        iconName="filter"
        iconNameOutline="filter"
        title={`${startCase(itemType)} Condition`}
        onClick={async () => {
          const eligible = await checkEligibility();
          if (eligible) open();
        }}
        visible={hasAccess()}
      />

      {isOpen && (
        <TaskConditionModal
          workflowId={workflowId}
          conditionsGroup={item?.conditionsGroup}
          isCreated={Boolean(item?.id)}
          itemId={item?.id}
          itemType={itemType}
          subtitle={getConditionModalSubtitle()}
          disabled={!hasAccess()}
          order={item?.order}
          onClose={close}
          onDone={(data) => {
            onConfigChange({ ...item, ...data });
          }}
        />
      )}
    </React.Fragment>
  );
}

Conditions.propTypes = {
  item: PropTypes.object,
  itemType: PropTypes.oneOf(["task", "nextWorkflow"]),
  workflowId: PropTypes.string.isRequired,
  onConfigChange: PropTypes.func.isRequired,
  checkEligibility: PropTypes.func,
};

Conditions.defaultProps = {
  item: null,
  itemType: "task",
  checkEligibility: async () => {
    return true;
  },
};

export default Conditions;
